/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Add_Subject_TitleInputs */



/**
* | output |
* | --- |
* | "Add a user or team" |
*
* @param {Rights_Tools_Add_Subject_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_add_subject_title = /** @type {((inputs?: Rights_Tools_Add_Subject_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Add_Subject_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzer oder Team hinzufügen")
	return /** @type {LocalizedString} */ ("Add a user or team")
});